export default "__VITE_ASSET__BciDSjOj__"